module.exports = __webpack_public_path__ + "img/tribe-rare.28d567dc.svg";